export const toastService = {

    showRootToast(title, message, type, root) {
        root.$bvToast.toast(message, {
            title: title,
            toaster: 'b-toaster-top-right',
            solid: true,
            variant: type,
            appendToast: true,
            noAutoHide:true
        })
        this.toastFocus()
    },
    toastFocus() {
        setTimeout(() => {
            let elem = document.getElementsByClassName("toast")
            elem = elem[elem.length-1]
            elem.focus()
        }, 100)
    },
}